import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {UserPermissionManager} from './user-permission';
import {CrmSection} from '@enum/crm-section';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';

class VestaDevPermissionClass implements UserPermission {
  readonly userRole = UserRole.VESTA_DEV;
  readonly labelRole = 'Vesta Dev';
  readonly isAuthenticated = true;

  readonly canRequestEto = false;
  readonly isDefaultUntaxedPrice = false;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = false;

  readonly hasMoreClients = false;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = false;
  readonly canHaveManyEditableProforma = false;
  readonly canModifyCountry = false;

  readonly canRegisterShopVendorFinalUser = false;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = false;
  readonly crmSectionsVisible = [];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = [];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [];
  readonly visibleUserAreaColumns = [];

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = false;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = false;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = false;
  readonly canDownloadPackingList = false;
  readonly canSeeConfigurationList = false;
  readonly canSeeCustomerConfigurationTab = false;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = false;

  readonly composerAllowed = true;
}

const VestaDevPermission = new VestaDevPermissionClass();

UserPermissionManager.instance.assignPermissionForRole(VestaDevPermission);
